import { ServiceAreaMarker } from './ServiceAreaMarker';
import { useMapContext } from '../../../hooks/MapProvider';
import {
    getPageUrl,
    useAnalyticsClickEvent,
    useAnalyticsViewEvent,
} from 'rwl-ui';
import { ClickTargets, ViewTargets } from 'rwl-shared/dist/models/analytics';
import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models';
import { useContentDetails } from '../../../providers';

export const ServiceAreaMarkers = () => {
    const { neighborhood, clusters } = useMapContext();
    const { closeDetails } = useContentDetails();
    const sendViewEvent = useAnalyticsViewEvent();
    const sendClickEvent = useAnalyticsClickEvent();

    const handleOnHover = (serviceArea: NeighborhoodServiceAreaInfo) => {
        sendViewEvent({
            url: getPageUrl(),
            target: ViewTargets.SERVICE_AREA_SUMMARY,
            serviceArea: serviceArea.postcode,
        });
    };

    const handleOnClick = (serviceArea: NeighborhoodServiceAreaInfo) => {
        closeDetails();
        sendClickEvent({
            url: getPageUrl(),
            target: ClickTargets.SERVICE_AREA,
            serviceArea: serviceArea.postcode,
        });
    };

    return (
        <>
            {!neighborhood &&
                clusters.map((cluster, index) => {
                    const {
                        centroid: position,
                        serviceAreas: areas,
                        totalJobs,
                    } = cluster;
                    if (totalJobs === 0) {
                        return null;
                    } else if (areas.length === 1) {
                        const area = areas[0];
                        return (
                            <ServiceAreaMarker
                                key={index}
                                position={position}
                                serviceArea={area}
                                onHover={(action: string) =>
                                    action === 'enter' && handleOnHover(area)
                                }
                                onClick={() => handleOnClick(area)}
                            />
                        );
                    } else {
                        return (
                            <ServiceAreaMarker
                                key={index}
                                position={position}
                                totalJobs={totalJobs}
                                isCluster={true}
                                serviceAreas={areas}
                            />
                        );
                    }
                })}
        </>
    );
};
